import { render, staticRenderFns } from "./ConsultaVotante.vue?vue&type=template&id=07802561&scoped=true"
import script from "./ConsultaVotante.vue?vue&type=script&lang=js"
export * from "./ConsultaVotante.vue?vue&type=script&lang=js"
import style0 from "./ConsultaVotante.vue?vue&type=style&index=0&id=07802561&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07802561",
  null
  
)

export default component.exports